export default {
  "content": "<path d=\"M3 13.019L10 6l7 7.019-1.294 1.281L10 8.58 4.294 14.3 3 13.019z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};